import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './Grid.scss';
import pageStyles from '../Page/Page.public.scss';
var containerProps = {
  children: PropTypes.node,
  fluid: PropTypes.bool,
  className: PropTypes.string,

  /** Applies min-height in order to fit to `<Page.Content/>`  */
  stretchVertically: PropTypes.bool
};

var RawContainer = function RawContainer(_ref) {
  var _classNames;

  var children = _ref.children,
      fluid = _ref.fluid,
      className = _ref.className,
      stretchVertically = _ref.stretchVertically;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.rawContainer, className, (_classNames = {}, _defineProperty(_classNames, styles.fluidContainer, fluid), _defineProperty(_classNames, pageStyles.pageStretchContentVertically, stretchVertically), _classNames)),
    children: children
  });
};

RawContainer.propTypes = containerProps;

var Container = function Container(_ref2) {
  var _classNames2;

  var children = _ref2.children,
      fluid = _ref2.fluid,
      className = _ref2.className,
      stretchVertically = _ref2.stretchVertically;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wixContainer, className, (_classNames2 = {}, _defineProperty(_classNames2, styles.fluidContainer, fluid), _defineProperty(_classNames2, pageStyles.pageStretchContentVertically, stretchVertically), _classNames2)),
    children: children
  });
};

Container.propTypes = containerProps;

var Columns = /*#__PURE__*/function (_Component) {
  _inherits(Columns, _Component);

  var _super = _createSuper(Columns);

  function Columns() {
    _classCallCheck(this, Columns);

    return _super.apply(this, arguments);
  }

  _createClass(Columns, [{
    key: "render",
    value: function render() {
      var _classNames3;

      var _this$props = this.props,
          className = _this$props.className,
          rtl = _this$props.rtl,
          stretchViewsVertically = _this$props.stretchViewsVertically,
          dataHook = _this$props.dataHook,
          children = _this$props.children;
      var rowClasses = classNames(styles.row, className, (_classNames3 = {}, _defineProperty(_classNames3, styles.rtl, rtl), _defineProperty(_classNames3, styles.stretch_vertically_row, stretchViewsVertically), _classNames3));
      return /*#__PURE__*/React.createElement("div", {
        className: rowClasses,
        "data-hook": dataHook,
        children: children
      });
    }
  }]);

  return Columns;
}(Component);

_defineProperty(Columns, "propTypes", {
  children: PropTypes.node,
  className: PropTypes.string,
  rtl: PropTypes.bool,
  stretchViewsVertically: PropTypes.bool,
  dataHook: PropTypes.string
});

_defineProperty(Columns, "defaultProps", {
  stretchViewsVertically: false
});

var AutoAdjustedColumns = /*#__PURE__*/function (_Component2) {
  _inherits(AutoAdjustedColumns, _Component2);

  var _super2 = _createSuper(AutoAdjustedColumns);

  function AutoAdjustedColumns() {
    var _this;

    _classCallCheck(this, AutoAdjustedColumns);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "DEFAULT_MAX_SPAN", 12);

    return _this;
  }

  _createClass(AutoAdjustedColumns, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var cols = Array.isArray(children) ? children.filter(function (child) {
        return Boolean(child);
      }) : [children];
      var spanSize = Math.floor(this.DEFAULT_MAX_SPAN / cols.length);
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(styles.row, styles.flexContainer)
      }, cols.map(function (col, index) {
        return /*#__PURE__*/React.createElement(Col, {
          span: spanSize,
          key: index,
          children: col
        });
      }));
    }
  }]);

  return AutoAdjustedColumns;
}(Component);

_defineProperty(AutoAdjustedColumns, "propTypes", {
  children: PropTypes.node
});

var Col = /*#__PURE__*/function (_Component3) {
  _inherits(Col, _Component3);

  var _super3 = _createSuper(Col);

  function Col() {
    _classCallCheck(this, Col);

    return _super3.apply(this, arguments);
  }

  _createClass(Col, [{
    key: "isVisibleHidden",
    value: function isVisibleHidden(str) {
      return str === 'hidden' || str === 'visible';
    }
  }, {
    key: "isLegalCol",
    value: function isLegalCol(numStr) {
      if (numStr && !this.isVisibleHidden(numStr)) {
        var num = Number(numStr);
        return Number.isInteger(num) && num > 0 && num <= 12;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _colClesses, _objectSpread2;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          span = _this$props2.span,
          rtl = _this$props2.rtl,
          xs = _this$props2.xs,
          sm = _this$props2.sm,
          md = _this$props2.md,
          lg = _this$props2.lg,
          xl = _this$props2.xl,
          dataHook = _this$props2.dataHook;
      var colClesses = (_colClesses = {}, _defineProperty(_colClesses, styles["colXs".concat(span)], this.isLegalCol(span)), _defineProperty(_colClesses, styles["colXs".concat(xs)], this.isLegalCol(xs)), _defineProperty(_colClesses, styles["colSm".concat(sm)], this.isLegalCol(sm)), _defineProperty(_colClesses, styles["colMd".concat(md)], this.isLegalCol(md)), _defineProperty(_colClesses, styles["colLg".concat(lg)], this.isLegalCol(lg)), _defineProperty(_colClesses, styles["colXl".concat(xl)], this.isLegalCol(xl)), _colClesses);
      var columnClasses = classNames(className, styles.col, _objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, styles.rtl, rtl), _defineProperty(_objectSpread2, styles["".concat(xs, "Xs")], this.isVisibleHidden(xs)), _defineProperty(_objectSpread2, styles["".concat(sm, "Sm")], this.isVisibleHidden(sm)), _defineProperty(_objectSpread2, styles["".concat(md, "Md")], this.isVisibleHidden(md)), _defineProperty(_objectSpread2, styles["".concat(lg, "Lg")], this.isVisibleHidden(lg)), _objectSpread2), colClesses), {}, _defineProperty({}, styles.legalCol, Object.values(colClesses).includes(true))));
      return /*#__PURE__*/React.createElement("div", {
        className: columnClasses,
        "data-hook": dataHook,
        children: children
      });
    }
  }]);

  return Col;
}(Component);

_defineProperty(Col, "propTypes", {
  children: PropTypes.node,
  className: PropTypes.string,
  span: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rtl: PropTypes.bool,
  xs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  md: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xl: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataHook: PropTypes.string
});

_defineProperty(Col, "defaultProps", {
  span: 12
});

export { Container, RawContainer, Columns, Columns as Row, AutoAdjustedColumns, AutoAdjustedColumns as AutoAdjustedRow, Col };